import _ from 'lodash';
import { guid } from '@/mixins/guid';

export default function carousel() {
  return {
    _id: false,
    type: 'droplet.carousel',
    firstUpload: false,
    images: _.times(6, i => ({
      _id: guid.methods.guid(),
      src: `${process.env.S3_ASSETS_URL}mock-images/default-images/image-${i + 1}.svg`,
      altText: false,
      pageLink: false,
      customLink: false,
      newWindow: false,
    })),
    visible: '4',
    delay: '2',
    showAll: false,
    itemLimit: 5,
    controls: 'show',
    mediaQueries: [],
    pageCSS: '',
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/carousel/droplet.schema.js